<template>
  <base-modal
    :ref="modal.key"
    :show="showResultsModal"
    @on-confirm="hideModal()"
    :okText="$t('Ok')"
    @on-cancel="hideModal()"
    :showCancelButton="false"
    :title="modalTitle"
  >
  <v-container>
      <v-simple-table>
        <thead>
          <tr>
            <th>{{ $t('Code') }}</th>
            <th>{{ $t('Value') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in results" :key="index">
            <td>{{ item.FieldCode }}</td>
            <td>{{ item.FieldValueRecognized }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-container>
  </base-modal>
</template>

  <script>
export default {
    name: 'InfomaniakResultsModal',
    props: {
        results: {
            type: Array,
            default: null,
        },
    },
    components: {},
    data() {
        return {
            showResultsModal: false,
            modal: {
                title: `${this.$t('SwissLLM')} - ${this.$t('Results')}`,
                key: 'infomaniakResultsModal',
            },

        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        modalTitle() {
            return this.modal.title;
        },
    },
    methods: {
        hideModal() {
            this.showResultsModal = false;
        },

        showModal() {
            this.showResultsModal = true;
        },
    },
};
</script>
